export class UnitsModel {
  id: number;
  cod: string;
  description: string;


  constructor(id?: number, cod?: string, description?: string) {
    this.id = id;
    this.cod = cod;
    this.description = description;
  }
}
